import { useCallback, useState } from 'react'
import { ProjectStatus } from '../../../../lib/functions/project'

export interface ProjectClosingStatusSearchCondition {
  projectStatus?: ProjectStatus[]
  closingStatus?: string[]
}

export const getDefaultSearchCondition =
  (): ProjectClosingStatusSearchCondition => ({
    projectStatus: [ProjectStatus.INPROGRESS],
    closingStatus: ['false'],
  })

export const useSearchCondition = (
  initialCondition?: ProjectClosingStatusSearchCondition
) => {
  const [searchCondition, setSearchCondition] =
    useState<ProjectClosingStatusSearchCondition>(
      initialCondition || getDefaultSearchCondition()
    )

  const onChange = useCallback(
    (updated: Partial<ProjectClosingStatusSearchCondition>) => {
      setSearchCondition(prev => ({ ...prev, ...updated }))
    },
    []
  )

  const resetCondition = useCallback(() => {
    setSearchCondition(getDefaultSearchCondition())
  }, [])

  return {
    searchCondition,
    onChange,
    resetCondition,
  }
}

export const useOnSingleValueChangedGenerator = (
  searchCondition: ProjectClosingStatusSearchCondition,
  onChangeCondition: (
    updated: Partial<ProjectClosingStatusSearchCondition>
  ) => void
) => {
  const onChangeValueGenerator = useCallback(
    (field: keyof ProjectClosingStatusSearchCondition) => (value: any) => {
      const updatedCondition = { [field]: value }
      onChangeCondition(updatedCondition)
    },
    [onChangeCondition]
  )

  return { onChangeValueGenerator }
}
